import React from "react";
import styles from "./Copyright.scss";
import { getCurrentTime } from "../../../services";

const Copyright = ({ className }) => (
  <div className={`${styles.copyRight} ${className}`}>
    {`${"Index Oglasi Copyright ©"} ${getCurrentTime().getFullYear()}`}
  </div>
);

export default Copyright;



// WEBPACK FOOTER //
// ./src/components/Footer/Copyright/Copyright.tsx